import { useState } from "react";
import {
  Box,
  Menu,
  MenuItem,
  Typography,
  Divider,
} from "@mui/material";
import {  
  Dashboard,
  Business,
  ShoppingCart,
  AccountBalance,
  People,
  BarChart,
  KeyboardArrowDown,
  KeyboardArrowRight,
  Settings,
  Groups,
} from "@mui/icons-material";
import { NavLink, useHistory } from "react-router-dom";
import { usePermissions } from "./usePermissions";

const HorizontalNavbar = () => {
  const history = useHistory();
  const {
    canReadMaster,
    canReadTransaction,
    canReadAccounts,
    canReadAdministration,
    canReadReports,
  } = usePermissions();
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [nestedAnchorEl, setNestedAnchorEl] = useState(null);
  const [activeNestedMenu, setActiveNestedMenu] = useState(null);

  const handleMenuOpen = (event, menuId) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(menuId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveMenu(null);
    setNestedAnchorEl(null);
    setActiveNestedMenu(null);
  };

  const handleNestedMenuOpen = (event, menuLabel) => {
    event.stopPropagation();
    // Always set the new anchor and menu - this handles switching between submenus
    setNestedAnchorEl(event.currentTarget);
    setActiveNestedMenu(menuLabel);
  };

  const handleNestedMenuClose = () => {
    setNestedAnchorEl(null);
    setActiveNestedMenu(null);
  };

  const handleNavigation = (path) => {
    history.push(path);
    handleMenuClose();
  };

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: <Dashboard sx={{ fontSize: 18 }} />,
      route: '/Home',
      permission: true,
    },
    {
      id: 'master',
      label: 'Master',
      icon: <Business sx={{ fontSize: 18 }} />,
      permission: canReadMaster,
      subItems: [
        {
          label: 'Account Master',
          isNested: true,
          subItems: [
            { label: 'Account Head', route: '/AccountHeadIndex' },
            { label: 'Asset', route: '/AssetIndex' },
            { label: 'Capital', route: '/CapitalIndex' },
            { label: 'Others', route: '/OtherOptionIndex' },
            { label: 'Balance Sheet', route: '/BalanceSheetHeadIndex' },
          ]
        },
        {
          label: 'HR',
          isNested: true,
          subItems: [
            { label: 'Department', route: '/DepartmentIndex' },
            { label: 'Designation', route: '/DesignationIndex' },
            { label: 'Staff', route: '/StaffDashboard' },
          ],
        },
        { label: 'Bank', route: '/BankIndex' },
        { label: 'Company', route: '/CompanyEdit' },
        {
          label: 'Master',
          isNested: true,
          subItems: [
            { label: 'Customer', route: '/ClientIndex' },
            { label: 'Supplier', route: '/VendorIndex' },
          ]
        },
        {
          label: 'Product',
          isNested: true,
          subItems: [
            { label: 'Category', route: '/ProductCategoryIndex' },
            { label: 'Brand', route: '/ProductBrandIndex' },
            { label: 'Item', route: '/ProductItemIndex' },
            // { label: 'Product Relations', route: '/ProductRelationIndex' },
          ]
        },
        { label: 'Terms & Conditions', route: '/TermsAndConditionsIndex' },

        // { label: 'Staff', route: '/StaffDashboard' },

      ],
    },

    {
      id: 'transaction',
      label: 'Transaction',
      icon: <ShoppingCart sx={{ fontSize: 18 }} />,
      permission: canReadTransaction,
      subItems: [
        {
          label: 'Purchase',
          isNested: true,
          subItems: [
            { label: 'Purchase Order', route: '/PurchaseOrderIndex' },
            { label: 'Purchase', route: '/PurchaseIndex' },
            { label: 'Purchase Return', route: '/PurchaseReturnAgainstIndex' },
          ]
        },
        {
          label: 'Sales',
          isNested: true,
          subItems: [
            // { label: 'Quotation', route: '/QuotationIndex' },
            // { label: 'Sales Order', route: '/SaleOrderIndex' },
            { label: 'Sales', route: '/SaleIndex' },
            { label: 'Sale Return', route: '/SaleReturnAgainstIndex' },
          ]
        },
      ],
    },
    {
      id: 'accounts',
      label: 'Accounts',
      icon: <AccountBalance sx={{ fontSize: 18 }} />,
      permission: canReadAccounts,
      subItems: [
        { label: 'Payment & Receipt', route: '/PaymentAndReceiptIndex' },
        { label: 'Journal Entry', route: '/JournalEntryIndex' },
        { label: 'Petty Cash', route: '/PettyCashIndex' },
      ],
    },
    {
      id: 'reports',
      label: 'Reports',
      icon: <BarChart sx={{ fontSize: 18 }} />,
      permission: canReadReports,
      subItems: [
        { label: 'Trial Balance', route: '/TrialBalanceReport' },
        { label: 'Trial Balance Advanced', route: '/TrialBalanceAdvancedReport' },
        { label: 'Cash Book', route: '/CashBook' },
        { label: 'Ledger', route: '/Ledger' },
        { label: 'Vendor Ageing', route: '/VendorAging' },
        { label: 'Customer Ageing', route: '/CustomerAging' },
        { label: 'Outstanding', route: '/Outstanding' },
        { label: 'Income Expense Summary', route: '/IncomeExpenseSummary' },
        { label: 'Petty Cash Book', route: '/PettyCashReport' },
        { label: 'Purchase Party & ItemWise Report', route: '/PurchasePartyandItemWiseReport' },
        { label: 'Sale Party & ItemWise Report', route: '/SalePartyandItemWiseReport' },
        { label: 'Stock Report', route: '/StockReport' },
        { label: 'Detailed Invoice', route: '/DetailedInvoiceReport' },
      ],
    },
    {
      id: 'auth',
      label: 'Auth',
      icon: <People sx={{ fontSize: 18 }} />,
      permission: canReadAdministration,
      subItems: [
        { label: 'Users', route: '/UserIndex' },
        { label: 'Roles', route: '/RoleIndex' },
        { label: 'User Permissions', route: '/UserPermissionIndex' },
        { label: 'Reset Password', route: '/PasswordChange' },
      ],
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: <Settings sx={{ fontSize: 18 }} />,
      permission: canReadMaster,
      subItems: [
        { label: 'Logout', route: '/Logout' },
      ],
    },
  ];

  const renderNestedMenu = (parentItem) => (
    <Menu
      anchorEl={nestedAnchorEl}
      open={activeNestedMenu === parentItem.label}
      onClose={handleNestedMenuClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      PaperProps={{
        sx: {
          background: "rgba(15, 23, 42, 0.96)",
          backdropFilter: "blur(16px)",
          color: 'white',
          minWidth: '220px',
          maxHeight: '70vh',
          overflowY: 'auto',
          ml: 0.75,
          borderRadius: '12px',
          border: '1px solid rgba(255, 255, 255, 0.08)',
          boxShadow: '0 10px 40px rgba(0,0,0,0.4)',
          p: 0.5,
        },
      }}
    >
      {parentItem.subItems?.map((subItem, idx) => (
        subItem.isDivider ? (
          <Box key={idx} sx={{ my: 0.75 }}>
            <Divider sx={{ borderColor: 'rgba(99, 102, 241, 0.25)', borderWidth: '0.5px' }} />
            <Typography
              sx={{
                color: '#818cf8',
                px: 2,
                py: 0.5,
                fontSize: '10px',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}
            >
              {subItem.label}
            </Typography>
          </Box>
        ) : (
          <MenuItem
            key={idx}
            onClick={() => handleNavigation(subItem.route)}
            sx={{
              fontSize: '13px',
              py: 0.8,
              px: 2,
              borderRadius: '6px',
              mx: 0.75,
              my: 0.25,
              transition: 'all 0.2s ease',
              '&:hover': { 
                backgroundColor: 'rgba(99, 102, 241, 0.15)',
                color: '#818cf8',
              },
            }}
          >
            {subItem.label}
          </MenuItem>
        )
      ))}
    </Menu>
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', height: '48px', gap: 0.5, ml: 3 }}>
      {menuItems.map((item) => {
        if (!item.permission) return null;

        if (item.route && !item.subItems) {
          return (
            <Box
              key={item.id}
              component={NavLink}
              to={item.route}
              sx={{
                display: 'flex', alignItems: 'center', gap: 0.75, px: 2, py: 1,
                color: 'rgba(255, 255, 255, 0.85)', textDecoration: 'none', cursor: 'pointer',
                fontSize: '13px', fontWeight: 600, height: '100%',
                transition: 'all 0.2s ease',
                borderRadius: '6px',
                mx: 0.25,
                '&:hover': { 
                  color: 'white',
                  backgroundColor: 'rgba(255,255,255,0.08)'
                },
                '&.active': { 
                  color: '#818cf8',
                  backgroundColor: 'rgba(99, 102, 241, 0.15)',
                  fontWeight: 700,
                },
              }}
            >
              <Box sx={{ display: 'flex', color: 'inherit' }}>{item.icon}</Box>
              <Typography sx={{ fontSize: '13px', fontWeight: 'inherit' }}>{item.label}</Typography>
            </Box>
          );
        }

        return (
          <Box key={item.id}>
            <Box
              onClick={(e) => handleMenuOpen(e, item.id)}
              sx={{
                display: 'flex', alignItems: 'center', gap: 0.75, px: 2, py: 1,
                color: activeMenu === item.id ? '#818cf8' : 'rgba(255, 255, 255, 0.85)', 
                cursor: 'pointer', fontSize: '13px', fontWeight: 600, height: '48px',
                transition: 'all 0.2s ease',
                borderRadius: '6px',
                mx: 0.25,
                '&:hover': { 
                  color: 'white',
                  backgroundColor: 'rgba(255,255,255,0.08)' 
                },
                ...(activeMenu === item.id && { backgroundColor: 'rgba(99, 102, 241, 0.15)' }),
              }}
            >
              <Box sx={{ display: 'flex', color: 'inherit' }}>{item.icon}</Box>
              <Typography sx={{ fontSize: '13px', fontWeight: 'inherit' }}>{item.label}</Typography>
              <KeyboardArrowDown sx={{ fontSize: 16, ml: 0.25, color: 'inherit' }} />
            </Box>

            <Menu
              anchorEl={anchorEl}
              open={activeMenu === item.id}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              PaperProps={{
                sx: {
                  background: "rgba(15, 23, 42, 0.96)",
                  backdropFilter: "blur(16px)",
                  color: 'white',
                  minWidth: '200px',
                  mt: 0.75,
                  borderRadius: '12px',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  boxShadow: '0 10px 40px rgba(0, 0, 0, 0.4)',
                  p: 0.5,
                },
              }}
            >
              {item.subItems?.map((subItem, idx) => (
                subItem.isNested ? (
                  <Box key={idx}>
                    <MenuItem
                      onClick={(e) => handleNestedMenuOpen(e, subItem.label)}
                      sx={{
                        fontSize: '13px', 
                        py: 1, 
                        px: 2,
                        borderRadius: '6px',
                        mx: 0.75,
                        my: 0.25,
                        display: 'flex', 
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        transition: 'all 0.2s ease',
                        '&:hover': { 
                          backgroundColor: 'rgba(99, 102, 241, 0.15)',
                          color: '#818cf8',
                        },
                        ...(activeNestedMenu === subItem.label && { 
                          backgroundColor: 'rgba(99, 102, 241, 0.2)',
                          color: '#818cf8',
                        }),
                      }}
                    >
                      {subItem.label}
                      <KeyboardArrowRight sx={{ fontSize: 16 }} />
                    </MenuItem>
                    {renderNestedMenu(subItem)}
                  </Box>
                ) : (
                  <MenuItem
                    key={idx}
                    onClick={() => handleNavigation(subItem.route)}
                    sx={{ 
                      fontSize: '13px', 
                      py: 1, 
                      px: 2,
                      borderRadius: '6px',
                      mx: 0.75,
                      my: 0.25,
                      transition: 'all 0.2s ease',
                      '&:hover': { 
                        backgroundColor: 'rgba(99, 102, 241, 0.15)',
                        color: '#818cf8',
                      } 
                    }}
                  >
                    {subItem.label}
                  </MenuItem>
                )
              ))}
            </Menu>
          </Box>
        );
      })}
    </Box>
  );
};

export default HorizontalNavbar;
